export function ticketHotkeyGoPrev(hotkeys, $rootScope) {
  'ngInject';
  hotkeys.add({
    combo: 'left',
    description: 'Go to previous view',
    callback: () => $rootScope.$broadcast('goPrev')
  });
}

export function ticketHotkeyGoNext(hotkeys, $rootScope) {
  'ngInject';
  hotkeys.add({
    combo: 'right',
    description: 'Go to next view',
    callback: () => $rootScope.$broadcast('goNext')
  });
}
